module.exports = __webpack_public_path__ + "22995ecee00820600b1639300acdb88e.png";